import {dashboardChartColors} from '../../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../../common/BarchartColumn';

export const prop = 'status';
export const id = 'controlsColumn';

export const config = (labels) =>
	barchartColumnConfig({
		fullId: id,
		label: labels.controls,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.nonTesting,
				data: [2],
				color: dashboardChartColors.teal[2]
			},
			{
				name: utilLabels.testing,
				data: [1],
				color: dashboardChartColors.teal[1]
			}
		]
	});
